<form [formGroup]="priceForm" (ngSubmit)="onSubmit()">
  <ng-container formArrayName="pricedetail">
    <div *ngFor="let detail of pricedetail.controls; let i = index" [formGroup]="detail">
      <div fxLayout.xs="column" fxLayout="row">
        <div fxFlex.xs="100" fxFlex="70">
          <mat-form-field fxFlex>
            <mat-label>Title</mat-label>
            <input [attr.guide]="'price-table-plan-inp-title' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" matInput
              formControlName="title" />
          </mat-form-field>
        </div>
        <div fxFlex.xs="100" fxFlex="30">
          <button [attr.guide]="'price-table-plan-btn-1' + '__' + sanitizeUrl(url)" mat-raised-button color="warn" (click)="deletePricingDetail(i)">Delete</button>
        </div>
      </div>
      <ng-container formArrayName="list_detail">
        <div *ngFor="let item of detail.get('list_detail').controls; let j = index" [formGroup]="item"
          style="border: 1px solid lightgray;padding: 15px;margin: 5px;">
          <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10px">
            <mat-form-field fxFlex>
              <mat-label>Sub Title</mat-label>
              <input [attr.guide]="'price-table-plan-inp-sub-title' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" matInput
                formControlName="sub_title" />
            </mat-form-field>

            <mat-form-field fxFlex>
              <mat-label>Starter</mat-label>
              <input [attr.guide]="'price-table-plan-inp-starter' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" matInput
                formControlName="starter" />
            </mat-form-field>

          </div>
          <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10px">
            <mat-form-field fxFlex>
              <mat-label>Button Name</mat-label>
              <input [attr.guide]="'price-table-plan-inp-button-name' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" matInput
                formControlName="button_name" />
            </mat-form-field>

            <mat-form-field fxFlex>
              <mat-label>Navigation</mat-label>
              <mat-select formControlName="navigation" name="item">
                <mat-option *ngFor="
                            let item of navigation;
                            let i = index
                          " [value]="item.value">
                  {{ item.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field *ngIf="item.get('navigation')?.value === 1" fxFlex>
              <mat-label>Button Link</mat-label>
              <input [attr.guide]="'price-table-plan-inp-button-link' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" matInput
                formControlName="button_link" />
            </mat-form-field>

            <mat-form-field *ngIf="item.get('navigation')?.value === 0" fxFlex>
              <mat-label>ID Element</mat-label>
              <input [attr.guide]="'price-table-plan-inp-id-element' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" matInput
                formControlName="id_element" />
            </mat-form-field>

            <mat-form-field *ngIf="item.get('navigation')?.value === 2"  fxFlex>
              <mat-label>Dynamic Form</mat-label>
              <mat-select formControlName="value" [disableOptionCentering]="true" #singleSelect name="item">
                <mat-option>
                  <ngx-mat-select-search name="Dynamic Form Search" ngDefaultControl [formControl]="
                          dynamicFormFilterControl
                            " placeholderLabel="Dynamic Form Search" [preventHomeEndKeyPropagation]="
                              true
                            " noEntriesFoundLabel="No data found">
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let opt of filtereddynamicFormTypeList;" [value]="opt.formGroupId">
                  {{ opt.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10px">
            <mat-form-field fxFlex>
              <mat-label>Profession</mat-label>
              <input [attr.guide]="'price-table-plan-inp-profession' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" matInput
                formControlName="profession" />
            </mat-form-field>

            <mat-form-field fxFlex>
              <mat-label>Advanced</mat-label>
              <input [attr.guide]="'price-table-plan-inp-advanced' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" matInput
                formControlName="advanced" />
            </mat-form-field>

            <mat-form-field fxFlex>
              <mat-label>Table Color</mat-label>
              <input [attr.guide]="'price-table-plan-inp-table-color' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()" [autocomplete]="'off'" matInput
                formControlName="table_color" />
            </mat-form-field>

            <div fxFlex>
              <button [attr.guide]="'price-table-plan-btn-2' + '__' + sanitizeUrl(url)" mat-raised-button color="warn" (click)="deleteListDetail(i, j)">Delete</button>
            </div>
          </div>

        </div><br />
        <button [attr.guide]="'price-table-plan-btn-3' + '__' + sanitizeUrl(url)" mat-raised-button (click)="addListDetail(i)">Add List Detail</button>
      </ng-container><br />
    </div><br />
    <button [attr.guide]="'price-table-plan-btn-4' + '__' + sanitizeUrl(url)" mat-raised-button (click)="addPricingDetails()">Add Pricing Detail</button>
  </ng-container><br />
  <button [attr.guide]="'price-table-plan-btn-5' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" style="margin-top: 10px;margin-bottom: 10px;">{{btntext}}</button>
</form>